import React from 'react'
import styled from 'styled-components'
import { BridalPlanProps } from '../../BridalPlan.types'
import { styleTheme } from '../../../../style/theme'
import { Slider } from 'customer/pages/FairDetail/components/Slider'
import { ConfigType } from 'customer/pages/Reservation/components/Form/Form.types'
import { useConfig } from 'customer/routes'

type HeaderProps = {
  className?: string
  plan: BridalPlanProps | undefined
}

export const Header = (props: HeaderProps) => {
  const config = useConfig() as ConfigType

  const createSliderImages = (plan: BridalPlanProps | undefined): Array<{ src: string; alt: string }> => {
    const sliderImages = plan
      ? [{ src: plan.mainImageData?.threeToTwoImage?.url || plan.mainImageData?.url, alt: plan.name }]
      : []

    plan?.bridalPlanImagesData?.forEach((imageData) => {
      if (imageData.url) {
        sliderImages.push({
          src: imageData.threeToTwoImage?.url || imageData.url,
          alt: plan.name,
        })
      }
    })

    return sliderImages.filter((image) => image.src) // `src` が空でないもののみを返す
  }

  const images = createSliderImages(props.plan)

  return <StyledComponent {...props} images={images} primaryColor={config.primaryColor || '#1babbc'} />
}

type ComponentProps = HeaderProps & {
  images: Array<{ src: string; alt: string }>
  primaryColor: string
}

const Component = (props: ComponentProps) => (
  <div className={props.className}>
    <div className="header">
      <div className="subtitle">
        <h2>{props.plan?.name}</h2>
      </div>
      <div className="image-wrapper"></div>
      <div className="slider">
        <Slider images={props.images} primaryColor={props.primaryColor} />
      </div>
    </div>
  </div>
)

const StyledComponent = styled(Component)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0 16px;
  text-align: center;

  > .header {
    text-align: center;

    > .subtitle {
      > h2 {
        text-align: left;
        font-size: 24px;
        line-height: 36px;
        font-weight: lighter;
        color: ${styleTheme.colors.black};
      }

      margin-top: 32px;
    }
    > .image-wrapper {
      max-width: 800px;
      display: flex;

      justify-content: center;
    }

    > .slider {
      max-width: 660px;
      margin: 20px auto 20px;
    }

    @media (max-width: 520px) {
      width: 100%;
      padding: 0 2%;
    }
  }
`
